<template>
  <div class="user-mgmt">
    <v-data-table v-if="users" :headers="headers" :items="users" sort-by="username" :search="search" item-key="_id"
      hide-default-footer @page-count="pageCount = $event" :page.sync="page" :items-per-page="itemsPerPage"
      no-data-text="No hay resultados" no-result-text="No hay resultados">
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line
            hide-details></v-text-field>
          <v-spacer></v-spacer>

          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" small class="mb-2" v-bind="attrs" v-on="on">
                <v-icon>person_add</v-icon>
              </v-btn>
            </template>

            <user-edit @onClose="close" :itemToEdit="editedItem" :dialog="dialog" />
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.isAdmin="{ item }">{{ item.isAdmin ? 'Si' : 'No' }}</template>
      <template v-slot:item.isEditor="{ item }">{{ item.isEditor ? 'Si' : 'No' }}</template>
      <template v-slot:item.isSupervisor="{ item }">{{ item.isSupervisor ? 'Si' : 'No' }}</template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
        <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
      </template>

      <template v-slot:footer>
        <v-pagination class="py-5" v-model="page" :length="pageCount" :total-visible="10"></v-pagination>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { userService } from '@/services/userService';
import { tableHeader } from '@/services/constData'
import UserEdit from '@/components/UserEdit'
export default {
  data() {
    return {
      users: null,
      search: '',
      page: 1,
      itemsPerPage: 20,
      pageCount: 0,
      editedItem: null,
      dialog: false,
      headers: null
    }
  },
  created() {
    this.headers = tableHeader.user
    this.loadUsers()
  },
  methods: {
    editItem(item) {
      this.editedItem = item
      this.dialog = true
    },
    async loadUsers() {
      this.$store.commit('user/toggleLoader')
      const users = await userService.query();
      this.users = users
      this.$store.commit('user/toggleLoader')
    },
    async deleteItem(item) {
      confirm('Estás seguro de que quieres eliminar este usuario?') &&
        await userService.remove(item._id)
      this.loadUsers()
    },

    close() {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = null
        this.loadUsers()
      })
    }
  },
  watch: {
    dialog(val) {
      val || this.close()
    },
  },
  components: {
    UserEdit
  }
}
</script>